export const styledMenubar = {
    alignItems: 'center',
    borderBottom: '1px solid $menubarBorder',
    boxSizing: 'border-box',
    display: 'flex',
    flex: 'none',
    flexDirection: 'row',
    height: '$menubarHeight',
    padding: '$menubarPaddingVertical $menubarPaddingHorizontal',
}

export const styledActionContainer = {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'flex-end',
}

export const styledActions = {
    alignItems: 'center',
    display: 'flex',
    flex: 'none',
}

export const styledMembers = {
    alignItems: 'center',
    display: 'flex',
    flexGrow: 1,
    justifyContent: 'flex-end',
}

export const defaultMenuBarContainer = {
    display: 'flex',
    position: 'relative',
    width: '100%',
}

export const defaultMenuBarWrapper = {
    alignItems: 'center',
    color: '$breadcrumbText',
    display: 'flex',
    flexShrink: 0,
    gap: '5px',
    variants: {
        hidden: {
            true: {
                left: '0',
                position: 'absolute',
                visibility: 'hidden',
            },
        },
    },
}

export const chevronWrapper = {width: '14px'}
